<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a role="button"
       v-on:click="toggleNavMenu()"
       :class="`navbar-burger burger ${ isMenuActive ? 'is-active' : ''}`"
       aria-label="menu" aria-expanded="false" data-target="navMenu">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navMenu"
       :class="`navbar-menu ${ isMenuActive ? 'is-active' : ''}`">
    <div class="navbar-start has-text-centered">
      <router-link class="navbar-item" to="/">
      <div class="container">
        <div class="item-title">Home</div>
        <div class="item-subtitle has-no-line title-ch is-size-6">
          <span class="material-icons">home</span>
        </div>
      </div>
      </router-link>

      <router-link class="navbar-item" to="/tributes">
        <div class="container">
          <div class="item-title">Tributes</div>
          <div class="item-subtitle title-ch is-size-6">留言</div>
        </div>
      </router-link>
      <router-link class="navbar-item" to="/gallery">
        <div class="container">
          <div class="item-title">Gallery</div>
          <div class="item-subtitle title-ch is-size-6">相册</div>
        </div>
      </router-link>
      <router-link class="navbar-item" to="/donate">
        <div class="container">
          <div class="item-title">Donate</div>
          <div class="item-subtitle title-ch is-size-6">捐赠</div>
        </div>
      </router-link>
    </div>
  </div>
</nav>
</template>

<style lang="scss">
@import "@/assets/vars.scss";

.navbar {
  text-transform: uppercase;
  font-size: 1.5em;
  font-weight: 300;

  .navbar-start {
    flex-grow: 1;
    justify-content: center;
  }

  .navbar-item, .navbar-burger{
    color: $light;
  }
  .navbar-item:hover {
    color: $lightest;
    background-color: rgba(224, 221, 207, 0.2);
  }

  .navbar-item.router-link-exact-active .item-title {
    text-decoration-line: underline;
  }
  .navbar-item.router-link-exact-active .item-title.has-no-line {
    text-decoration-line: none;
  }

  .navbar-item .item-subtitle {
    line-height: 1.3;
    font-size:16px;
  }

   .navbar-item .material-icons {
    line-height: 1.3;
    display: block;
    font-size: 16px
  }


}
</style>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuActive: false,
    };
  },
  methods: {
    toggleNavMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
  },
};
</script>
